module.exports = __webpack_public_path__ + "img/4.e2b05c2b.jpg";